// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1R0_u","controls":"styles_controls__39bcV","charLimit":"styles_charLimit__jMq1a","input":"styles_input__3L_ym","send":"styles_send__32q42"};